/* unplugin-vue-components disabled */import { render } from "./formAssembly.vue?vue&type=template&id=99a2450a&scoped=true"
import script from "./formAssembly.vue?vue&type=script&lang=js"
export * from "./formAssembly.vue?vue&type=script&lang=js"

import "./formAssembly.vue?vue&type=style&index=0&id=99a2450a&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a2450a"]])

export default __exports__